class reportesService {//servicios para login
  axios
  baseUrl

  constructor(axios, baseUrl, baseUrlApi) {
    this.axios = axios;
    this.baseUrl = `${baseUrl}`;
    this.baseUrlApi = `${baseUrlApi}`;
  }
  
  getReportePendientePago(fecha,colaborador_id) {
    return this.axios.get(`${this.baseUrl}/reporte/pendiente_pago/${fecha}/${colaborador_id}`)
  }

  getReporteSeguimientoPago(fecha,colaborador_id) {
    return this.axios.get(`${this.baseUrl}/reporte/seguimiento/${fecha}/${colaborador_id}`)
  }

  obtenerPdfComprasVentas(usuario_id,mes,anio){
    return this.axios.get(`${this.baseUrl}/reporte/pdf/libro_compras_ventas/${usuario_id}/${mes}/${anio}`); 
  }

  obtenerCierreAnual(anio,usuario_id){
    let url = `${this.baseUrl}/cierre/anual/pdf/${usuario_id}/${anio}`
    return this.axios.get(url);
  }

  obtenerCierreAnualROS(anio,usuario_id){
    let url = `${this.baseUrl}/cierre/anual_ROS/pdf/${usuario_id}/${anio}`
    return this.axios.get(url);
  }

  reporteMaestroMes(fecha){
    let url = `${this.baseUrl}/reporte/maestro/mes/${fecha}`
    return this.axios.get(url);
  }

  reporteMasivo(fecha_inicio,fecha_fin,nit,tipo_archivo){
    let url = `${this.baseUrl}/reporte/documentos_sat?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}&nit=${nit}&tipo_archivo=${tipo_archivo}`
    return this.axios.get(url);
  }

  buscarDocumentosSat(body){
    let url = `${this.baseUrlApi}/buscar_documentos_sat`
    return this.axios.post(url, body);
  }

  descargarLibroComprasVentas(body) {
    let url = `${this.baseUrlApi}/buscar_libros_pdf`;
    return this.axios.post(url, body);
  }

  reporteDeFacturasPasarelaPago(body) {
    let url = `${this.baseUrl}/reporte/pasarela`;
    return this.axios.post(url, body);
  }

  reporteUsuariosSinFormaPago() {
    let url = `${this.baseUrl}/reporte/usuarios_sin_forma_pago`;
    return this.axios.get(url);
  }
}

export default reportesService;